import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import StickyDiv from 'components/StickyDiv';
import Link from 'components/Link';
// import { format } from 'date-fns';
import { connect } from 'react-redux';
import _get from 'lodash.get';
// import { updateSearchOverlayStatus } from 'routes/articleshow_v2/redux';
//import Image from 'components/Image';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { runAbExperiment } from 'utils/experimentUtils';
import { UserPreferenceContext } from 'routes/home/layouts/India/context';
import JarvisAdUnit from 'helpers/ads/JarvisAdUnit';
import {
  debounce,
  inViewForReact,
  checkAndRedirectToHomePage,
  isPrimeUser,
} from 'utils/common';
import { checkJarvisIsAdActive } from 'helpers/ads/utils';
import { getGeoCountry, checkIsSaleLive, getSeoName } from 'utils/primeUtil';
import {
  // isSessionStorage,
  // setSearchOverLayAlreadyShown,
  // updateSearchOverlayPageViewCount,
  // showSearchOverlayPopuponPageView,
  // isPageExcluded,
  checkSearchBarShownCookieExists,
  setSearchBarShownCookie,
} from 'utils/searchOverlayUtils';
import OnetapsigninV2 from 'components/Login/OnetapsigninV2';
//import Link from '../Link';
// import Navigation from '../Navigation';
//import TopBar from './TopBar/TopBar';
import OpenInAppTopWidget from 'components_v2/mobile/OpenInAppTopWidget/OpenInAppTopWidgetLoader';
// import OpenInAppTopBand from 'components_v2/mobile/OpenInAppTopBand/OpenInAppTopBand'; // Remove the Loader Implementation once AB experiment is turned off
import AddOrgSchema from 'components_v2/common/AddOrgSchema';
import Login from 'components/Login';
// import WithTimesPoint from 'modules/WithTimesPoint';
import LoadMenu from 'components_v2/mobile/Menu/MenuLoadableLoader';
import AdCaller from 'helpers/ads/adCaller';
import WithGeo from 'helpers/ads/WithGeo';
import OpenInAppBtn from 'components_v2/mobile/OpenInAppBtn';
import { gaWrapper } from 'helpers/analytics';
import {
  TIMESCLUB_CTA_NAV,
  TOI_PLUS_PLAN_PAGE_URL,
  TOI_LIVE_MOBILE_DOMAIN,
  // TOI_DOMAIN,
  TIMES_SPECIAL_NOC_NAME,
  TOI_EPAPER_URL_MWEB,
} from 'constants/index';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import ListingHeader from './ListingHeader';
import SearchWrapper from '../SearchWrapper/SearchWrapperLoader';
// import SearchOverlayPopup from '../SearchOverlayPopup/SearchOverlayPopup';
import s from './Header.scss';
// import LocationCity from '../LocationBar/LocationCity';
// import LocationPopup from '../LocationBar/LocationPopup';
import CoachMark from '../CoachMark/CoachMark';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';
// import { l1NavSections } from '../../../constants/NavSections';

// const activityEvents = [
//   'mousedown',
//   'touchmove',
//   'keypress',
//   'touchstart',
//   'scroll',
// ];

class Header extends React.Component {
  static contextType = UserPreferenceContext;
  constructor(props) {
    super();
    this.state = {
      openInAppStickyVisible: false,
      openMenu: false,
      isFixedHeader: false,
      isHeaderInView: true,
      masthead: props.headerData && props.headerData.masthead,
      // showSearchOverlayPopup: false,
      openSearchFrm: '',
      showSearchBar: false,
      searchBarClicked: false,
      headerVariant: undefined,
      showL2: false,
      selectedTab: '',
      showCoachMark: false,
      isSaleLive: false,
      isHeaderSlugActive: false,
    };
    // headerOpenAppLink: To be controlled from feed once Header variant experiment closes.
    this.headerOpenAppLink = '';
    if (props.pageType) {
      if (props.pageType === 'ARTICLESHOW') {
        this.headerOpenAppLink =
          'https://timesofindia.onelink.me/efRt/ASheader';
      }
    }
    this.hideSearchOverlay = true;
    this.prvPos = 0;
    this.debouncedHandleScroll = debounce(this.handleScroll.bind(this), 10);
    this.openInAppToggled = this.openInAppToggled.bind(this);
    this.isPrimeUser = false;
    this.defaultL1 = [
      { name: 'Top', path: '/', isTop: 'true', gaLabel: '' },
      { name: 'Briefs', path: '/briefs', gaLabel: '' },
      {
        name: 'TOI+',
        path: '/toi-plus',
        gaLabel: 'toiplus',
        styles: 'toiplus',
      },
      {
        name: 'Coronavirus',
        path: 'https://m.timesofindia.com/coronavirus',
        gaLabel: 'corona',
      },
      { name: 'Videos', path: '/videos', gaLabel: '' },
      { name: 'City', path: '/city', gaLabel: '' },
    ];
  }
  openInAppToggled({ visible }) {
    this.setState({ openInAppStickyVisible: visible });
  }
  handleScroll() {
    let { isFixedHeader } = this.state;
    const elem = document.querySelector(`header.${s.mobile}`);
    const isHeaderInView = !!(elem && inViewForReact(elem, 0, true, true));
    const position = document.body.getBoundingClientRect();
    if (position.top === 0) {
      isFixedHeader = false;
    } else if (position.top >= this.prvPos) {
      isFixedHeader = true; //up scroll
    } else {
      isFixedHeader = false; //down scroll
    }

    if (
      this.state.isHeaderInView !== isHeaderInView ||
      this.state.isFixedHeader !== isFixedHeader
    ) {
      this.setState({ isFixedHeader, isHeaderInView });
    }
    const refreshButton = document.getElementById('refresh-button');
    if (refreshButton && !isHeaderInView) {
      refreshButton.classList.add('sticky');
    } else if (refreshButton && isHeaderInView) {
      refreshButton.classList.remove('sticky');
    }
    window.isStickyHeader = !isHeaderInView;
    this.prvPos = position.top;
  }

  static findL1FromURL(pathname) {
    return (
      pathname.length > 1 &&
      pathname.split('/').length > 0 &&
      pathname.split('/')[1]
    );
  }

  handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      clearTimeout(this.inactivityTimer);
    } else {
      this.resetIdleTimer();
    }
  };
  getCityPathSecondParameter = () => {
    const path = window.location.pathname;
    if (path.includes('/city')) {
      if (path.includes('/pollution-news')) {
        return 'pollution news';
      }
      const pathParts = path.split('/');
      if (pathParts.length > 2) {
        // The city name is at index 2
        const cityName = pathParts[2];
        return cityName;
      }
    }
    // Return an empty string if city name is not found
    return '';
  };

  componentDidMount() {
    if (typeof checkIsSaleLive === 'function') {
      this.setState({ isSaleLive: checkIsSaleLive() });
    }
    if (typeof document !== 'undefined' && this.props.toipLayout) {
      const activeNav = document.getElementById('activeNav');
      const navBar = document.getElementById('navigationBar');
      if (activeNav && navBar) {
        const navBarWidth = navBar.offsetWidth;
        const activeNavWidth = activeNav.offsetWidth;
        const scrollOffset =
          activeNav.offsetLeft - (navBarWidth - activeNavWidth) / 2;

        navBar.scrollTo(scrollOffset, 0);
      }
    }
    const geo = getGeoCountry()?.toLowerCase();
    if (geo) {
      document.body.classList.add(`geo-${geo}`);
    }
    const { abHeaderId, abAdskey, pageType } = this.props;
    if (pageType === 'ARTICLESHOW') {
      runAbExperiment(abHeaderId, abAdskey, {
        0: () => this.setState({ headerVariant: 1 }),
        1: () => this.setState({ headerVariant: 2 }),
        default: () => this.setState({ headerVariant: 1 }),
      });
    }
    if (
      pageType === 'Home' ||
      pageType === 'Listing' ||
      this.props.enableHeaderUnificationVersion ||
      (typeof window !== 'undefined' &&
        window?.location?.pathname.includes('/pollution-news'))
    ) {
      if (typeof window !== 'undefined' && window?.location?.pathname === '/') {
        this.setState({ selectedTab: 'News', showL2: true });
        // l1Nav = this.props.l1NavSections ? this.props.l1NavSections : [];
      } else if (typeof window !== 'undefined' && this.props?.l1NavSections) {
        const location = window.location.pathname.split('/')[1];
        // if (location === 'elections') {
        //   location = 'elections 2023';
        // }
        let selected = this.props?.l1NavSections.filter(
          val => val?.name && val?.name.toLowerCase() === location,
        );
        const cityName = this.getCityPathSecondParameter();

        if (
          cityName &&
          selected &&
          selected[0] &&
          selected[0].name &&
          selected[0].path &&
          window?.location?.pathname.includes('/city') &&
          !this.props.disableCityNavBreakdown
        ) {
          selected[0].name = cityName;
          selected[0].path = `${TOI_LIVE_MOBILE_DOMAIN}${
            window?.location?.pathname
          }`;
        }
        const findIndex = this.props.l1NavSections.findIndex(
          el =>
            el?.name &&
            el?.name.toLowerCase() === selected[0]?.name.toLowerCase(),
        );
        if (findIndex === -1) {
          let pathName = window?.location?.pathname;
          if (pathName) {
            pathName = pathName.split('/');
            pathName =
              pathName &&
              Array.isArray(pathName) &&
              pathName.length > 0 &&
              pathName[1]
                ? pathName[1]
                : window?.location?.pathname;
            if (pathName === 'south-pole-by-chennai-times') {
              pathName = 'south pole - chennai times';
            } else if (pathName === 'voice-of-conscience') {
              pathName = 'voice of conscience';
            } else if (pathName && typeof pathName === 'string') {
              pathName = pathName.replace('-', ' ');
            }
            let hasL2 = false;
            const dynamicPathsWithL2 = [
              'gadgets news',
              'astrology',
              'elections',
              'speaking tree',
              'technology',
            ];
            if (dynamicPathsWithL2.includes(pathName)) {
              hasL2 = true;
            }
            this.props.l1NavSections.push({
              name: pathName,
            });
            selected = [
              {
                name: '',
              },
            ];
            selected[0].name = pathName;
            selected[0].hasL2 = hasL2;
            this.arraymove(
              this.props.l1NavSections,
              this.props.l1NavSections.length - 1,
              1,
            );
          }
        } else {
          this.arraymove(this.props.l1NavSections, findIndex, 1);
        }

        this.setState({
          selectedTab: selected[0]?.name,
          showL2: selected[0]?.hasL2 ? selected[0]?.hasL2 : false,
        });
        if (location === 'cartoons') {
          this.setState({ showL2: true });
        }
        if (
          selected[0]?.hasL2 &&
          selected[0]?.name?.toLowerCase() === 'city' &&
          typeof window !== 'undefined' &&
          !localStorage.getItem('showCoachMark')
        ) {
          localStorage.setItem('showCoachMark', true);
          this.setState({
            showCoachMark: true,
          });
        }
      }
    }

    if (
      pageType === 'Home' ||
      pageType === 'Listing' ||
      this.props.enableHeaderUnificationVersion ||
      (typeof window !== 'undefined' &&
        window?.location?.pathname.includes('/pollution-news'))
    ) {
      // runAbExperiment('rNiNNh3wToKFATea_d2_Yw', '', {
      //   0: () => {
      //     this.setState({ newHeader: 1 });
      //     if (typeof window !== 'undefined') {
      //       localStorage.setItem('newHeader', false);
      //     }
      //   },
      //   1: () => {
      //     this.setState({ newHeader: 2 }, () => {
      //       if (typeof window !== 'undefined') {
      //         localStorage.setItem('newHeader', true);
      //       }
      //     });
      //   },
      //   default: () => {
      //     this.setState({ newHeader: 1 });
      //     if (typeof window !== 'undefined') {
      //       localStorage.setItem('newHeader', false);
      //     }
      //   },
      // });
    }

    const { layoutType } = this.props;
    if (typeof window !== 'undefined' && window.location) {
      const l1Path =
        (window.location.pathname &&
          Header.findL1FromURL(window.location.pathname)) ||
        '';
      if (!window.categoryForSearchGA)
        window.categoryForSearchGA = `WAP-TOI-Others-${l1Path}`;
    }
    window.addEventListener('scroll', this.debouncedHandleScroll);
    this.isPrimeUser = isPrimeUser();
    this.checkAndUpdateMastheadFrame();

    if (getGeoCountry() === 'US') {
      this.defaultL1 = [
        ...this.defaultL1.slice(0, 3),
        {
          name: 'Abound',
          path: `${TIMESCLUB_CTA_NAV}`,
          gaLabel: 'abound',
        },
        ...this.defaultL1.slice(3),
      ];
    }
    // if (!this.isArticleShowPage()) {
    //   updateSearchOverlayPageViewCount();
    // }
    // registering events to track if user is idle for few minutes
    // activityEvents.forEach(eventName => {
    //   window.addEventListener(eventName, this.resetIdleTimer, true);
    // });
    this.checkIsHeaderSlugAdActive();
    if (layoutType !== 'primeshow') {
      this.resetIdleTimer();
      if (document.addEventListener)
        document.addEventListener(
          'visibilitychange',
          this.handleVisibilityChange,
          false,
        );
      // this.isVidePlayingCheck = setInterval(this.isVideoPlaying, 2000);
      // const { openSearch } = this.state;

      // if (showSearchOverlayPopuponPageView()) {
      //   this.setState({
      //     showSearchOverlayPopup: true && !openSearch,
      //   });
      // }
      if (!this.props.enableHeaderUnificationVersion) {
        this.checkAndShowSearchBar();
      }
    }
    // if (this.state.newHeader && this.state.newHeader === 2) {
    // }
  }

  checkIsHeaderSlugAdActive = () => {
    this.setState({
      isHeaderSlugActive:
        !!(
          checkJarvisIsAdActive('headerSlug') &&
          this.props.headerSlugAdCodeObject
        ) &&
        !this.props.hideAds &&
        !this.props.isPrime,
    });
  };
  checkL2Page = () => {
    const { headerData } = this.props;
    if (
      headerData?.navigation &&
      headerData?.navigation.breadcrumbs &&
      Array.isArray(headerData?.navigation.breadcrumbs) &&
      headerData?.navigation.breadcrumbs.length > 2
    ) {
      return true;
    }
    return false;
  };

  checkAndShowSearchBar = () => {
    const searchBarShowStatus = checkSearchBarShownCookieExists();
    const isHomePage =
      this.props.pageType &&
      (this.props.pageType === 'Home' || this.props.pageType === 'HomeUs');
    const isToiPlusPage = this.props.toipLayout;
    const isL2PageWithHeading =
      ((this.checkL2Page() &&
        this.props.pageType &&
        this.props.pageType === 'Listing') ||
        this.props.pageType === 'PhotoList' ||
        this.props.pageType === 'dataListicle') &&
      this.props.headerType;
    const isOneTapActive =
      typeof window !== 'undefined' && window.onetapActiveFlag;

    if (
      !isOneTapActive &&
      searchBarShowStatus &&
      !isHomePage &&
      !isToiPlusPage &&
      !isL2PageWithHeading &&
      !(this.state.headerVariant && this.state.headerVariant === 2) &&
      !this.props.isLiveblogListing
    ) {
      this.setState({ showSearchBar: true });
      if (searchBarShowStatus === 1) {
        /**
         * searchBarShowStatus === 1 means both cookie (isSearchBarShown and searchbarvisible) not exist,
         * searchBarShowStatus === 2 means both cookies (isSearchBarShown and searchbarvisible) exists
         * this need to be set only if both cookie not exists
         *  */
        setSearchBarShownCookie(true);
      }
      sendGaThroughProps({
        data: {
          gaCategory:
            typeof window !== 'undefined' && window.categoryForSearchGA
              ? window.categoryForSearchGA
              : '',
          gaAction: `Open_SearchBar-Search-View`,
          gaLabel: window.location.href,
          nonInteraction: true,
        },
      });
    }
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.debouncedHandleScroll);
    // activityEvents.forEach(eventName => {
    //   window.removeEventListener(eventName, this.resetIdleTimer);
    // });
  }

  componentDidUpdate(prevProps, prevState) {
    // Typical usage (don't forget to compare props):
    if (
      this.props.isSearchOpenedFrmMidArticle !==
        prevProps.isSearchOpenedFrmMidArticle &&
      this.props.isSearchOpenedFrmMidArticle
    ) {
      this.openSearch('widget');
    }
    if (
      this.state.headerVariant !== prevState.headerVariant &&
      (this.state.headerVariant && this.state.headerVariant === 2)
    ) {
      this.hideSearchBar();
    }
  }

  hideSearchBar = () => {
    this.setState({ showSearchBar: false });
  };

  arraymove = (arr, fromIndex, toIndex) => {
    const element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  };

  checkAndUpdateMastheadFrame = () => {
    const { masthead = {}, showSearchBar, isHeaderSlugActive } = this.state;
    const { hideLogoMastHead, headerType } = this.props;
    const isMastheadActive =
      !hideLogoMastHead &&
      !headerType &&
      !showSearchBar &&
      !!masthead.innovation &&
      !isHeaderSlugActive;
    if (isMastheadActive && masthead.timeout > 0) {
      let newobj = {};
      if (
        masthead.settledFrame &&
        masthead.settledFrame.data &&
        masthead.settledFrame.data.src
      ) {
        newobj = masthead.settledFrame;
      }
      setTimeout(() => {
        this.setState(
          {
            masthead: newobj,
          },
          this.checkAndUpdateMastheadFrame,
        );
      }, masthead.timeout);
    }
  };

  openSearch = (frm = '') => {
    const { toipLayout } = this.props;
    this.setState({
      openSearch: true,
      openSearchFrm: frm,
    });
    let gaAction = 'ActionBar';
    if (frm === 'widget') {
      gaAction = 'Widget';
    } else if (frm === 'overlay') {
      gaAction = 'Overlay';
    } else if (frm === 'searchBar') {
      gaAction = 'Open_SearchBar';
    }
    if (toipLayout) {
      sendGaThroughProps({
        data: {
          gaCategory: 'WEB-Prime-AS',
          gaAction: `NavBar-Search`,
          gaLabel: 'Click',
        },
      });
    }
    sendGaThroughProps({
      data: {
        gaCategory:
          typeof window !== 'undefined' && window.categoryForSearchGA
            ? window.categoryForSearchGA
            : '',
        gaAction: `${gaAction}-Search-Click`,
        gaLabel: window.location.href,
      },
    });
  };

  closeSearch = () => {
    const { toipLayout } = this.props;
    const { searchBarClicked } = this.state;
    this.setState({
      openSearch: false,
    });
    if (typeof this.props.updateMwebOpenSearchStatus === 'function') {
      this.props.updateMwebOpenSearchStatus();
    }
    if (toipLayout) {
      sendGaThroughProps({
        data: {
          gaCategory: 'WEB-Prime-AS',
          gaAction: `NavBar-Search`,
          gaLabel: 'Close',
        },
      });
    }
    sendGaThroughProps({
      data: {
        gaCategory:
          typeof window !== 'undefined' && window.categoryForSearchGA
            ? window.categoryForSearchGA
            : '',
        gaAction: `${
          searchBarClicked ? 'Open_SearchBar' : 'ActionBar'
        }-Search-Close`,
        gaLabel: window.location.href,
      },
    });
    this.setState({ searchBarClicked: false });
  };

  openMenu = () => {
    const { toipLayout, pageType } = this.props;
    this.setState({
      openMenu: true,
    });
    if (
      pageType === 'Home' ||
      pageType === 'Listing' ||
      this.props.enableHeaderUnificationVersion
    ) {
      sendGaThroughProps({
        data: {
          gaCategory: 'mobile_unified_header',
          gaAction: 'click_H3_hemburge_menu_open',
          gaLabel: `${this.state.selectedTab}_${this.props.pageType}`,
        },
      });
    } else {
      sendGaThroughProps({
        data: {
          gaCategory: toipLayout ? 'WAP-Prime-AS' : 'nav_menu',
          gaAction: toipLayout ? 'NavBar-Hamburger' : 'hamburger_menu',
          gaLabel: toipLayout ? 'Open' : 'hamburger_open',
        },
      });
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'header',
        category: 'hamburger',
      });
    }

    sendGaThroughProps({
      data: {
        gaCategory: 'mWeb_nav_menu_toi',
        gaAction: 'social_profile_icons',
        gaLabel: 'view',
        nonInteraction: true,
      },
    });
  };

  closeMenu = () => {
    const { toipLayout } = this.props;
    this.setState({
      openMenu: false,
    });
    if (toipLayout) {
      sendGaThroughProps({
        data: {
          gaCategory: 'WAP-Prime-AS',
          gaAction: 'NavBar-Hamburger',
          gaLabel: 'Close',
        },
      });
    }
  };

  getHomeNode = (homeNode = {}, extLink, isTechnology = false) => {
    const _headingType = homeNode.headingType || 'h2';
    const CustomTag = `${_headingType}`;
    // const { headerData, showShortLogo } = this.props;
    // const theme = headerData.colorTheme;
    const link = extLink || homeNode.link || '/';
    const { toipLayout, pageType } = this.props;
    let linkAttr = {};
    if (extLink) {
      linkAttr = {
        target: '_blank',
      };
    }

    return (
      <CustomTag className={`${s.fulllogo} ${s.snowwhite}`}>
        <Link
          to={
            isTechnology
              ? `https://timesofindia.indiatimes.com/technology`
              : link
          }
          data={
            pageType === 'Home' ||
            pageType === 'Listing' ||
            this.props.enableHeaderUnificationVersion
              ? {
                  gaCategory: 'mobile_unified_header',
                  gaAction: 'click_H3_toi_title_click',
                  gaLabel: `${this.state.selectedTab}_${this.props.pageType}`,
                }
              : {
                  gaCategory: 'nav_menu',
                  gaAction: 'toi_logo',
                  gaLabel: '',
                }
          }
          title="News"
          alt="News"
          ga4Data={[
            {
              event: 'user_click',
              type: 'header',
              label: 'toi_logo',
            },
          ]}
          doNotChangeDomain
          {...linkAttr}
          className={`${toipLayout ? s.fulllogoLink : ''}`}
        />
      </CustomTag>
    );
  };

  getEachHeaderItem = (val, isL2 = null) => {
    const { gaCategory, pageType, userData, toipLayout } = this.props;
    const isLoggedIn =
      userData && userData.isLoggedIn ? userData.isLoggedIn : false;
    const prcValue = userData && userData.prcValue ? userData.prcValue : 0;
    return (
      <li
        className={`${val?.name === 'Pollution News' ? s.active_red : ''} ${
          (pageType === 'Home' ||
            pageType === 'Listing' ||
            this.props.enableHeaderUnificationVersion) &&
          val?.isTop === 'true'
            ? s.active
            : ''
        }  `}
      >
        <Link
          key={val?.name}
          to={
            this.state.isSaleLive && val.name === 'TOI+'
              ? TOI_PLUS_PLAN_PAGE_URL
              : val?.path || val?.link
          }
          id={`${
            toipLayout &&
            pageType !== 'Home' &&
            pageType !== 'Listing' &&
            !this.props.enableHeaderUnificationVersion &&
            val?.isTop === 'true'
              ? 'activeNav'
              : ''
          }`}
          className={`${
            (pageType === 'Home' ||
              pageType === 'Listing' ||
              this.props.enableHeaderUnificationVersion) &&
            this.state.selectedTab &&
            this.state.selectedTab.toLowerCase() === val?.name?.toLowerCase()
              ? s.active
              : ''
          } ${
            pageType !== 'Home' &&
            pageType !== 'Listing' &&
            !this.props.enableHeaderUnificationVersion &&
            val?.isTop === 'true'
              ? s.active
              : ''
          }
          ${
            (!this.props.l1NavSections ||
              this.props.l1NavSections.length === 0) &&
            (pageType === 'Home' ||
              pageType === 'Listing' ||
              this.props.enableHeaderUnificationVersion) &&
            val?.isTop === 'true'
              ? s.active
              : ''
          }
           ${val?.styles ? s[val.styles] : ''} ${
            this.state.isSaleLive && val.name === 'TOI+' ? s.sale : ''
          } ${
            getSeoName(val?.name) === TIMES_SPECIAL_NOC_NAME ? s.newbadge : ''
          }`}
          doNotChangeURL
          // subText={val?.subText}
          // data={{
          //   gaAction: 'NavBar-SectionClick',
          //   gaLabel: `NavBar-${val.gaLabel || val.name}/${index +
          //     1}`,
          // }}
          onClick={e => {
            if (val?.isTop) {
              checkAndRedirectToHomePage(e);
            }
            if (pageType && toipLayout && !this.props.isVideoshowPage) {
              sendGaThroughProps({
                data: {
                  gaCategory: 'TOI Plus',
                  gaAction: `TOIPlus_topTab_${val.name || val.gaLabel}_click`,
                  gaLabel: `Ps-${
                    !isLoggedIn && prcValue === 0 ? -1 : prcValue
                  }`,
                },
              });
            } else if (
              (pageType === 'Home' ||
                pageType === 'Listing' ||
                this.props.enableHeaderUnificationVersion) &&
              isL2
            ) {
              sendGaThroughProps({
                data: {
                  gaCategory: 'mobile_unified_header',
                  gaAction: `click_L2_${val?.name}_L1_${
                    this.state.selectedTab
                  }`,
                  gaLabel: `${this.state.selectedTab}_${this.props.pageType}`,
                },
              });
            } else {
              sendGaThroughProps({
                data: {
                  gaCategory:
                    pageType !== 'Home' &&
                    pageType !== 'Listing' &&
                    !this.props.enableHeaderUnificationVersion
                      ? gaCategory || 'nav_menu'
                      : 'mobile_unified_header',
                  gaAction:
                    pageType !== 'Home' &&
                    pageType !== 'Listing' &&
                    !this.props.enableHeaderUnificationVersion
                      ? `L1_${val?.gaLabel || val.name}`
                      : `click_L1_${val?.name}`,
                  gaLabel:
                    pageType !== 'Home' &&
                    pageType !== 'Listing' &&
                    !this.props.enableHeaderUnificationVersion
                      ? typeof window !== 'undefined' && window?.location?.href
                      : `${this.state.selectedTab}_${this.props.pageType}`,
                },
              });
            }
            analyticsWrapper('ga4', {
              event: 'user_click',
              type: 'header',
              category: 'l1',
              label: val?.name.toLowerCase(),
            });
          }}
        >
          {val?.name === 'TOI+' ? (
            <>
              <img
                className={s.toiImg}
                src="https://static.toiimg.com/photo/95641191.cms"
                alt="Menu"
              />
              {this.state.isSaleLive ? <span> Sale</span> : null}
            </>
          ) : (
            val?.name
          )}
        </Link>
      </li>
    );
  };

  toiPlusClick = () => {
    sendGaThroughProps({
      data: {
        gaCategory: 'mobile_unified_header',
        gaAction: `click_L1_TOI+`,
        gaLabel: `${this.state.selectedTab}_${this.props.pageType}`,
      },
    });

    if (typeof window !== 'undefined') {
      window.location.href = `${TOI_LIVE_MOBILE_DOMAIN}/toi-plus`;
    }
  };
  isArticleShowPage = () => {
    const path = location.href;
    return path.indexOf(`articleshow`) > -1;
  };

  // closeSearchPopup = () => {
  //   this.setState({ showSearchOverlayPopup: false });
  //   setSearchOverLayAlreadyShown();
  //   if (showSearchOverlayPopuponPageView()) {
  //     this.props.updateSearchOverlayStatus(false);
  //     sessionStorage.setItem('searchOverlayPageViewCount', 0);
  //     if (isSessionStorage()) {
  //       sessionStorage.setItem('isSearchOverlayAlreadyShown', 'no');
  //     }
  //   }
  // };

  resetIdleTimer = () => {
    clearTimeout(this.inactivityTimer);
    // this.inactivityTimer = setTimeout(() => {
    //   const { openSearch } = this.state;
    //   this.setState({ showSearchOverlayPopup: !openSearch });
    // }, SEARCH_OVERLAY_IDLE_TIME);
  };

  // isVideoPlaying = () => {
  // if (
  //   typeof window !== 'undefined' &&
  //   window.player &&
  //   ((window.player.store.isAdActive && window.player.store.isAdPlaying) ||
  //     (!window.player.store.video.completed &&
  //       !window.player.store.video.paused))
  // ) {
  //  this.resetIdleTimer();
  // }
  // };
  setClick = () => {
    this.setState({ showCoachMark: false });
  };
  // bellIconClick = () => {
  //   gaWrapper(
  //     'send',
  //     'event',
  //     'mobile_unified_header',
  //     'click_H3_bell_icon',
  //     `${this.state.selectedTab}_${this.props.pageType}`,
  //   );
  // };
  searchIconClick = () => {
    if (this.state.showSearchBar) {
      this.setState({ searchBarClicked: true });
      this.openSearch('searchBar');
    } else {
      this.openSearch();
    }

    gaWrapper(
      'send',
      'event',
      'mobile_unified_header',
      'click_H3_search',
      `${this.state.selectedTab}_${this.props.pageType}`,
    );
  };

  render() {
    const {
      isFixedHeader,
      openInAppStickyVisible,
      isHeaderInView,
      // showSearchOverlayPopup,
      openSearchFrm,
      showSearchBar,
      isHeaderSlugActive,
    } = this.state;
    const {
      headerData = {},
      hideL2Navigation,
      hideOpenInAppTopWidget,
      showHeaderOnScroll,
      hideStickyL2Nav,
      l1Sections,
      l2Sections,
      underToneAd,

      hideAds,
      headerType,
      headerLabel,
      hideLogoMastHead,
      searchKeyword,
      // isShowSearch,
      pageType,
      toipLayout,
      // geolocation,
      isMastHeadH1,
      mastheadText,
      // OpenInAppTopBandWidget,
      removeOneTap,
      // geoCityData,
      l1NavSections,
    } = this.props;
    const { userData } = this.props;
    const { openInApp, AmzTopDeals, isOpenInApp } = headerData;
    const homeNode = headerData.navigation && headerData.navigation.home;
    const { masthead = {} } = this.state;
    const isMastheadActive =
      !hideLogoMastHead &&
      !headerType &&
      !showSearchBar &&
      !!masthead.innovation &&
      !isHeaderSlugActive;
    const mastHeadLink = isMastheadActive ? masthead.link : '';
    // const isIndiaGeo = !geolocation || geolocation === '1';
    let l1SectionList = this.defaultL1;
    if (l1Sections && l1Sections.length > 0) {
      l1SectionList = l1Sections;
    }
    const isIndiaHomePage = pageType && pageType === 'Home';
    // const { geoCity } = this.context;
    // let intialCityForSection = null;
    // if (geoCityData && geoCityData?.city) {
    //   intialCityForSection = geoCityData?.city;
    // } else if (geoCity) {
    //   intialCityForSection = geoCity;
    // }

    if (
      (pageType === 'Home' ||
        pageType === 'Listing' ||
        this.props.enableHeaderUnificationVersion) &&
      l1NavSections
    ) {
      l1SectionList = l1NavSections;
    }

    if (
      (pageType === 'Home' ||
        pageType === 'Listing' ||
        this.props.enableHeaderUnificationVersion) &&
      this.state.showL2 &&
      !this.props.disableCityNavBreakdown &&
      l2Sections &&
      l2Sections.length > 0
    ) {
      const index = l2Sections.findIndex(
        el => el?.name.toLowerCase() === 'city',
      );
      if (index !== -1 && l2Sections[index] && l2Sections[index].name) {
        l2Sections[index].name = `${l2Sections[index].name} Home`;
      }
    }
    //let openInAppEmbedded = false;
    // if (
    //   headerData &&
    //   headerData.openInApp &&
    //   headerData.openInApp.position === 'header'
    // ) {
    //   openInAppEmbedded = true;
    // }

    // Please add this condition while enabling open in app button.
    // const isSafari = /iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(
    //   navigator.userAgent,
    // );
    // const APIUrl = `${TOI_DOMAIN}/feeds/web_navigation_feed_spadata.cms?category=changecity&feedtype=sjson`;
    // const listAPIUrl = __PROD__
    //   ? APIUrl
    //   : APIUrl.replace('timesofindia.indiatimes', 'toidev.indiatimes');

    const topband = this.props.jarvisConfig?.topBand?.isAdActive || null;
    const isCityListing =
      headerType &&
      typeof headerType === 'string' &&
      headerType.split('-')[1] === 'city';

    const url =
      this.props?.articleSectionData &&
      this.props.articleSectionData[this.props.msid] &&
      this.props.articleSectionData[this.props.msid].wu;

    let isSpeakingtree = false;

    if (
      (this.props.newsData &&
        this.props.newsData.navsubsecs &&
        this.props.newsData.navsubsecs.subsec1 &&
        this.props.newsData.navsubsecs.subsec1.subsecmsid1 === '106291237' &&
        pageType === 'Listing') ||
      (this.props.pageType === 'ARTICLESHOW' &&
        this.props.subSecSeoLocation === 'speaking-tree')
    ) {
      isSpeakingtree = true;
    } else {
      isSpeakingtree = false;
    }

    let isTechnology = false;

    if (
      this.props.newsData &&
      this.props.newsData.navsubsecs &&
      this.props.newsData.navsubsecs.subsec1 &&
      (this.props.newsData.navsubsecs.subsec1.subsecmsid1 === '106755835' ||
        this.props.newsData.navsubsecs.subsec1.subsecmsid1 === '100699880' ||
        this.props.newsData.navsubsecs.subsec1.subsecmsid1 === '66949542')
    ) {
      isTechnology = true;
    } else if (
      this.props.articleSectionData &&
      this.props.msid &&
      this.props.articleSectionData[this.props.msid] &&
      this.props.articleSectionData[this.props.msid].navsubsecs &&
      this.props.articleSectionData[this.props.msid].navsubsecs.subsec1 &&
      (this.props.articleSectionData[this.props.msid].navsubsecs.subsec1
        .subsecmsid1 === '106755835' ||
        this.props.articleSectionData[this.props.msid].navsubsecs.subsec1
          .subsecmsid1 === '100699880' ||
        this.props.articleSectionData[this.props.msid].navsubsecs.subsec1
          .subsecmsid1 === '66949542')
    ) {
      isTechnology = true;
    } else {
      isTechnology = false;
    }

    const ModifiedComponent = AddOrgSchema(
      this.getHomeNode(homeNode, mastHeadLink, isTechnology),
      toipLayout,
      this.props.isWapView,
      url,
    );

    return (
      <React.Fragment>
        {!hideAds &&
          !toipLayout &&
          !this.props.isPrime && <JarvisAdUnit type="topBand" isWapView />}
        {/* {!topband &&
          !hideOpenInAppTopWidget &&
          // !isSafari && // Please add this condition while enabling open in app button.
          <div
          // gaLabel="https://m.timesofindia.com"
          // gaCategory="TimesBetterIndiaPromo"
          // gaAction="seen"
          >
            <div className={s.timesbetter_banner}>
              <div
                className={s.topbandWrapper}
                onClick={() => {
                  if (this.state.newHeader && this.state.newHeader === 2) {
                    gaWrapper(
                      'send',
                      'event',
                      'mobile_unified_header',
                      'click_H1_top_band',
                      `${this.state.selectedTab}_${this.props.pageType}`,
                    );
                  }
                }}
              >
                <OpenInAppTopBandWidget
                  gaCategory="WAP-IN-NHP1"
                  isFixedHeader={isFixedHeader}
                />
              </div>
              <Link
                to="https://timesofabetterindia.com/big-picture-contest?utm_source=til&utm_medium=til&utm_campaign=toabi"
                data={{
                  gaCategory: 'TimesBetterIndiaPromo',
                  gaAction: 'click',
                  gaLabel: 'https://m.timesofindia.com',
                }}
              >
                <img
                  src="https://static.toiimg.com/photo/93291169.cms"
                  alt=""
                />
              </Link>
            </div>
          )} */}

        {!topband &&
          !hideOpenInAppTopWidget &&
          !isIndiaHomePage && (
            <OpenInAppTopWidget
              openInAppToggled={this.openInAppToggled}
              openInAppLink={openInApp && openInApp.path ? openInApp.path : ''}
            />
          )}
        {/* {!toipLayout &&
          (pageType === 'Home' || pageType === 'Listing') && (
            <div className={s.locationWrap}>
              <div>{format(new Date(), 'dddd, MMMM D, YYYY')}</div>
              <LocationCity
                data={listAPIUrl}
                geoCityData={this.props.geoCityData}
                defaultCity={intialCityForSection}
                pageType={this.props.pageType}
                selectedTab={this.state.selectedTab}
              />
              <LocationPopup data={listAPIUrl} />
            </div>
          )} */}

        {/* {!this.hideSearchOverlay &&
          (isShowSearch || showSearchOverlayPopup) &&
          !isPageExcluded() && (
            <SearchOverlayPopup
              openSearch={this.openSearch}
              closeSearchPopup={this.closeSearchPopup}
            />
          )} */}
        <header
          className={`${s.mobile} ${isFixedHeader ? s.fixHeader : ''} ${
            !isHeaderInView && (hideOpenInAppTopWidget || showHeaderOnScroll)
              ? s.sticky
              : ''
          }`}
        >
          <div
            className={`${s.headerwrapper} ${(headerType ||
              showSearchBar ||
              isHeaderSlugActive) &&
              s.noImg} ${isMastheadActive ? `${s[masthead.colorTheme]}` : ''}
              ${
                isTechnology && pageType === 'ARTICLESHOW' ? s.gadgetNow : ''
              } `}
            style={
              isMastheadActive
                ? {
                    backgroundColor: masthead.bgcolor || '#fff',
                    backgroundImage: `url(${masthead.data.src})`,
                    backgroundPosition: masthead.bgPosition || 'center',
                    backgroundSize: masthead.bgSize || 'cover',
                    backgroundRepeat: 'no-repeat',
                  }
                : {}
            }
          >
            <div className={s.hamburger} onClick={this.openMenu} />
            {this.state.openMenu && (
              <LoadMenu
                closeMenu={this.closeMenu}
                data={headerData}
                openMenu={this.state.openMenu}
                editionSwitch={this.props.headerData.editionSwitch}
                currentCountry={this.props.currentCountry}
                notificationCenter={this.props.headerData.notificationCenter}
                showTOIPlus={this.props.showTOIPlus}
                showToiPlusEntryPoints={this.props.showToiPlusEntryPoints}
                hideNotificationCenter
                msid={this.props.msid}
                articleSectionData={this.props.articleSectionData}
                newsData={this.props.newsData}
                liveblogData={this.props.liveblogData}
              />
            )}
            <div className={s.header_right}>
              {headerType || showSearchBar || isHeaderSlugActive ? (
                <>
                  <ListingHeader
                    data={headerType}
                    headerLabel={headerLabel}
                    h1Required={isMastHeadH1}
                    isExpandedSearchBarVisible={showSearchBar}
                    mastheadText={mastheadText}
                    selectedTab={this.state.selectedTab}
                    pageType={this.props.pageType}
                    enableHeaderUnificationVersion={
                      this.props.enableHeaderUnificationVersion
                    }
                    mastheadImageLogo={this.props.mastheadImageLogo}
                    pageCanonicalUrl={this.props?.newsData?.seo?.canonical}
                    isTechnology={isTechnology}
                  />
                  <InViewObserver
                    ga={{
                      action: 'NavBar-Header',
                      label: 'Header-readEpaperCTA-View',
                      category:
                        typeof window !== 'undefined'
                          ? window.categoryForGA
                          : '',
                    }}
                    className={s.epaperButtonWrapper}
                  >
                    <Link
                      type="button"
                      className={s.epaperButton}
                      to={TOI_EPAPER_URL_MWEB}
                      data-ga={`${
                        typeof window !== 'undefined'
                          ? window.categoryForGA
                          : ''
                      }|NavBar-Header|Header-readEpaperCTA-Click`}
                      ga4Data={[
                        {
                          event: 'user_click',
                          type: 'read_epaper',
                          category: 'header',
                        },
                      ]}
                    >
                      Read ePaper
                    </Link>
                  </InViewObserver>
                  {!this.props.toipLayout ? (
                    <>
                      {isHeaderSlugActive ? (
                        <JarvisAdUnit
                          type="headerSlug"
                          isWapView
                          adCodeInfo={this.props.headerSlugAdCodeObject}
                        />
                      ) : (
                        <div
                          className={`${
                            pageType === 'Home' ||
                            pageType === 'Listing' ||
                            this.props.enableHeaderUnificationVersion
                              ? s.header_right_inner
                              : s.searchbarwidth
                          }`}
                        >
                          {/* {this.state.newHeader &&   // will uncomment later when notification bell functionality is written
                        this.state.newHeader === 2 && (
                          <div className={`${s.notification}`}>
                            <span
                              className={`${s.icon}`}
                              onClick={() => {
                                this.bellIconClick();
                              }}
                            />
                          </div>
                        )} */}
                          <div
                            className={`${
                              pageType !== 'Home' &&
                              pageType !== 'Listing' &&
                              !this.props.enableHeaderUnificationVersion
                                ? s.search
                                : ''
                            } ${showSearchBar ? s.largeSearch : ''} ${
                              isCityListing && showSearchBar
                                ? s.largeSearchWidth
                                : ''
                            }`}
                          >
                            <span
                              className={`${
                                pageType === 'Home' ||
                                pageType === 'Listing' ||
                                this.props.enableHeaderUnificationVersion
                                  ? s.newSearchIcon
                                  : s.searchIcon
                              }`}
                              onClick={() => {
                                if (
                                  pageType === 'Home' ||
                                  pageType === 'Listing' ||
                                  this.props.enableHeaderUnificationVersion
                                ) {
                                  this.searchIconClick();
                                }
                              }}
                            />
                            {pageType !== 'Home' &&
                              pageType !== 'Listing' &&
                              !this.props.enableHeaderUnificationVersion && (
                                <input
                                  type="text"
                                  placeholder={
                                    showSearchBar
                                      ? 'Search latest news, videos, photos'
                                      : 'Search Here'
                                  }
                                  onClick={
                                    showSearchBar
                                      ? () => {
                                          this.setState({
                                            searchBarClicked: true,
                                          });
                                          this.openSearch('searchBar');
                                        }
                                      : this.openSearch
                                  }
                                />
                              )}
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className={`${s.smallSearch}`} />
                  )}
                  {this.state.openSearch ? (
                    <SearchWrapper
                      closeSearch={this.closeSearch}
                      isWapView
                      isHeadersearch
                      searchKeyword={searchKeyword}
                      openSearchFrm={openSearchFrm}
                      toipLayout={toipLayout}
                    />
                  ) : null}
                </>
              ) : (
                <>
                  {homeNode && <ModifiedComponent />}
                  {!isMastheadActive && (
                    <div className={s.header_right_inner}>
                      <InViewObserver
                        ga={{
                          action: 'NavBar-Header',
                          label: 'Header-readEpaperCTA-View',
                          category:
                            typeof window !== 'undefined'
                              ? window.categoryForGA
                              : '',
                        }}
                        className={s.epaperButtonWrapper}
                      >
                        <Link
                          type="button"
                          className={s.epaperButton}
                          to={TOI_EPAPER_URL_MWEB}
                          data-ga={`${
                            typeof window !== 'undefined'
                              ? window.categoryForGA
                              : ''
                          }|NavBar-Header|Header-readEpaperCTA-Click`}
                          ga4Data={[
                            {
                              event: 'user_click',
                              type: 'read_epaper',
                              category: 'header',
                            },
                          ]}
                        >
                          Read ePaper
                        </Link>
                      </InViewObserver>
                      {isOpenInApp &&
                        toipLayout && (
                          <OpenInAppBtn
                            gaCategory="OpenAppHeader"
                            gaAction="click"
                            openappUrl={this.props.openappUrl}
                          />
                        )}
                      {!toipLayout &&
                        this.headerOpenAppLink &&
                        this.state.headerVariant &&
                        this.state.headerVariant === 2 &&
                        !showSearchBar && (
                          <OpenInAppBtn
                            gaCategory={
                              typeof window !== 'undefined' &&
                              window?.categoryForGA
                                ? window?.categoryForGA
                                : 'OpenAppHeader'
                            }
                            gaViewAction="OpenApp_button_Seen"
                            gaAction="OpenApp_button_Click"
                            openappUrl={this.headerOpenAppLink}
                          />
                        )}
                      {/* Disabling OpenInApp button for new search design */}
                      {/* {headerData && headerData.isOpenInApp && (
                      <OpenInAppBtn
                        gaCategory="OpenAppHeader"
                        gaAction="click"
                        openappUrl={this.props.openappUrl}
                      />
                    )} */}
                      {AmzTopDeals &&
                        AmzTopDeals.isPresent && (
                          <WithGeo
                            render={({ geoCountry }) => {
                              if (geoCountry === 'US') {
                                return (
                                  <div className={s.AmzTopDeals}>
                                    <a
                                      href={AmzTopDeals.link}
                                      onClick={() => {
                                        gaWrapper(
                                          'send',
                                          'event',
                                          `${AmzTopDeals.ga}`,
                                          `NavBar-AppDownload`,
                                          window.location.href,
                                        );
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {AmzTopDeals.label}
                                    </a>
                                  </div>
                                );
                              }
                              return null;
                            }}
                          />
                        )}
                      {/* {this.state.newHeader &&    // will uncomment later when bell functionality is written
                        this.state.newHeader === 2 && (
                          <div className={`${s.notification}`}>
                            <span
                              className={`${s.icon}`}
                              onClick={() => {
                                this.bellIconClick();
                              }}
                            />
                          </div>
                        )} */}
                      {/* <button className={s.topicsearchicon}>Search</button> */}
                      {!this.props.toipLayout && (
                        <>
                          {(this.state.headerVariant &&
                            this.state.headerVariant === 1) ||
                          !(pageType === 'ARTICLESHOW') ? (
                            <div
                              className={`${
                                pageType !== 'Home' &&
                                pageType !== 'HomeUs' &&
                                pageType !== 'Listing' &&
                                !this.props.enableHeaderUnificationVersion
                                  ? s.search
                                  : ''
                              } ${showSearchBar ? s.largeSearch : ''}`}
                            >
                              <span
                                className={`${
                                  pageType === 'Home' ||
                                  pageType === 'HomeUs' ||
                                  pageType === 'Listing' ||
                                  this.props.enableHeaderUnificationVersion
                                    ? s.newSearchIcon
                                    : s.searchIcon
                                }`}
                                onClick={() => {
                                  if (
                                    pageType === 'Home' ||
                                    pageType === 'HomeUs' ||
                                    pageType === 'Listing' ||
                                    this.props.enableHeaderUnificationVersion
                                  ) {
                                    this.searchIconClick();
                                  }
                                }}
                              />
                              {pageType !== 'Home' &&
                                pageType !== 'HomeUs' &&
                                pageType !== 'Listing' &&
                                !this.props.enableHeaderUnificationVersion && (
                                  <input
                                    type="text"
                                    placeholder={
                                      showSearchBar
                                        ? 'Search latest news, videos, photos'
                                        : 'Search Here'
                                    }
                                    onClick={
                                      showSearchBar
                                        ? () => {
                                            this.setState({
                                              searchBarClicked: true,
                                            });
                                            this.openSearch('searchBar');
                                          }
                                        : this.openSearch
                                    }
                                  />
                                )}
                            </div>
                          ) : null}

                          {this.state.headerVariant &&
                          this.state.headerVariant === 2 ? (
                            <div className={`${s.toipSearchIcon}`} />
                          ) : null}
                        </>
                      )}
                      {!showSearchBar &&
                        toipLayout && (
                          <div
                            className={`${s.toipSearchIcon}`}
                            onClick={this.openSearch}
                          />
                        )}
                      {this.state.openSearch ? (
                        <SearchWrapper
                          closeSearch={this.closeSearch}
                          isWapView
                          isHeadersearch
                          searchKeyword={searchKeyword}
                          openSearchFrm={openSearchFrm}
                          toipLayout={toipLayout}
                        />
                      ) : null}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </header>
        {isSpeakingtree && (
          <div className="only_st_logo">
            <img src="https://static.toiimg.com/photo/107815704.cms" alt="" />
          </div>
        )}

        <Login isMobile />
        {/* <WithTimesPoint
          isWapView
          disableTimesPointWidget={this.props.disableTimesPointWidget}
        /> */}
        <div className="sticky-bottom-from-element" />
        {!hideL2Navigation && (
          <StickyDiv
            stickyClass={classNames({
              [s.stickyHeader]: true && !hideStickyL2Nav,
              [s.stickyHeaderZero]:
                !openInAppStickyVisible || hideOpenInAppTopWidget,
            })}
            outerContainerClass={`${s.l2_navigation_wrapper} ${
              s[headerData.colorTheme || 'snowwhite']
            } ${this.props.isVideoshowPage ? s.l2_wrapper_sticky : ''}
            ${
              pageType === 'Home' ||
              pageType === 'Listing' ||
              this.props.enableHeaderUnificationVersion
                ? s.headerUnification
                : ''
            }`}
            offsetFromTop={openInAppStickyVisible ? 56 : 0}
          >
            <div className={`${s.l2_navigation}`}>
              <ul id="navigationBar">
                {l1SectionList &&
                  l1SectionList.length > 0 &&
                  l1SectionList.map(
                    val =>
                      // if (val.name !== 'TOI+') {
                      this.getEachHeaderItem(val),
                    // }
                    // if (this.props.showToiPlusEntryPoints && ps) {
                    //   return this.getEachHeaderItem(val, index);
                    // }
                    //return null;
                    //   <li>
                    //     <Link
                    //       key={val.name}
                    //       to={val.path}
                    //       className={`${index === 0 ? s.active : ''} ${
                    //         val.styles ? s[val.styles] : ''
                    //       }`}
                    //       // data={{
                    //       //   gaAction: 'NavBar-SectionClick',
                    //       //   gaLabel: `NavBar-${val.gaLabel || val.name}/${index +
                    //       //     1}`,
                    //       // }}
                    //       onClick={e => {
                    //         if (val.isTop) {
                    //           checkAndRedirectToHomePage(e);
                    //         }

                    //         sendGaThroughProps({
                    //           data: {
                    //             gaCategory: 'nav_menu',
                    //             gaAction: `L1_${val.gaLabel || val.name}`,
                    //             gaLabel: window.location.href,
                    //           },
                    //         });
                    //       }}
                    //     >
                    //       {val.name === 'TOI+' ? '' : val.name}
                    //     </Link>
                    //   </li>
                    // ),
                  )}
              </ul>
              {/* {this.state.newHeader &&
                this.state.newHeader === 2 && (
                  <div className={`${s.newsFixed}`}>
                    <ul>
                      <li>
                        <Link
                          className={`
                           ${
                             this.state.newHeader &&
                             this.state.newHeader === 2 &&
                             this.state.selectedTab?.toLowerCase() === 'news'
                               ? s.active
                               : ''
                           } `}
                          to="https://m.timesofindia.com/"
                        >
                          NEWS
                        </Link>
                      </li>
                    </ul>
                  </div>
                )} */}
              {(pageType === 'Home' ||
                pageType === 'Listing' ||
                this.props.enableHeaderUnificationVersion) &&
                this.props.l1NavSections && (
                  <div
                    className={`${s.toiplusFixed}`}
                    onClick={this.toiPlusClick}
                  >
                    <img
                      src="https://static.toiimg.com/photo/89937428.cms"
                      alt=""
                      title=""
                      width={35}
                      height={11}
                    />
                  </div>
                )}
            </div>
          </StickyDiv>
        )}
        {typeof underToneAd === 'object' && (
          <WithGeo
            render={({ geoCountry }) => {
              const country =
                typeof geoCountry === 'string' ? geoCountry.toUpperCase() : '';
              if (underToneAd.geo.indexOf(country) > -1) {
                return (
                  <AdCaller
                    data={{
                      ...underToneAd,
                    }}
                    deviceType="mobile"
                  />
                );
              }
              return null;
            }}
          />
        )}
        {!removeOneTap && (
          <div
            id="g_id_onload"
            data-prompt_parent_id="g_id_onload"
            data-cancel_on_tap_outside="false"
            style={
              ({ position: 'fixed' },
              { left: '0' },
              { bottom: '50px' },
              { width: 0 },
              { height: 0 },
              { 'z-index': 1001 })
            }
          >
            {!this.props.toipLayout && (
              <OnetapsigninV2
                username={
                  userData && typeof userData.getEmail === 'function'
                    ? userData.getEmail()
                    : ''
                }
                isWapView
              />
            )}
          </div>
        )}

        {(pageType === 'Home' ||
          pageType === 'Listing' ||
          this.props.enableHeaderUnificationVersion) &&
        this.state.showL2 &&
        l2Sections &&
        l2Sections.length > 0 ? (
          <div
            className={`${s.nav} ${this.props.isPrime ? s.changePosition : ''}`}
          >
            {this.state.showCoachMark && (
              <CoachMark onClickOutside={this.setClick} />
            )}
            <ul>
              {l2Sections &&
                l2Sections.length > 0 &&
                l2Sections.map(val =>
                  // if (val.name !== 'TOI+') {
                  this.getEachHeaderItem(val, true),
                )}
            </ul>
          </div>
        ) : null}
      </React.Fragment>

      // { {this.props.params.isWapView &&
      //   !this.props.isPrivateUser && (
      //     <Onetapsignin
      //       username={
      //         userData && typeof userData.getEmail === 'function'
      //           ? userData.getEmail()
      //           : ''
      //       }
      //       isWapView={this.props.params.isWapView}
      //     />
      //   )} }
    );
  }
}

Header.propTypes = {
  headerData: PropTypes.shape({
    masthead: PropTypes.shape({}),
    editionSwitch: PropTypes.shape({}),
    notificationCenter: PropTypes.shape({}),
  }).isRequired,
  hideL2Navigation: PropTypes.bool,
  hideOpenInAppTopWidget: PropTypes.bool,
  currentCountry: PropTypes.string,
  l1Sections: PropTypes.arrayOf(PropTypes.shape({})),
  l2Sections: PropTypes.arrayOf(PropTypes.shape({})),
  showTOIPlus: PropTypes.bool,
  // showShortLogo: PropTypes.bool,
  userData: PropTypes.shape({
    getEmail: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    prcValue: PropTypes.number,
  }),
  underToneAd: PropTypes.shape({}),
  hideAds: PropTypes.bool,
  // geolocation: PropTypes.string,
  gaCategory: PropTypes.string,
  isOpenInApp: PropTypes.bool,
  headerType: PropTypes.string,
  showToiPlusEntryPoints: PropTypes.bool,
  headerLabel: PropTypes.string,
  hideLogoMastHead: PropTypes.bool,
  disableTimesPointWidget: PropTypes.bool,
  pageType: PropTypes.string,
  toipLayout: PropTypes.bool,
  // isShowSearch: PropTypes.bool,
  showHeaderOnScroll: PropTypes.bool,
  isPrime: PropTypes.bool,
  hideStickyL2Nav: PropTypes.bool,
  abHeaderId: PropTypes.string,
  abAdskey: PropTypes.string,
  isLiveblogListing: PropTypes.bool,
  mastheadText: PropTypes.string,
  isMastHeadH1: PropTypes.bool,
  jarvisConfig: PropTypes.shape({}),
  isWapView: PropTypes.bool,
  removeOneTap: PropTypes.bool,
  l1NavSections: PropTypes.arrayOf(PropTypes.shape({})),
  headerSlugAdCodeObject: PropTypes.shape({}),
  enableHeaderUnificationVersion: PropTypes.bool,
  disableCityNavBreakdown: PropTypes.bool,
  isUsHomePage: PropTypes.bool,
  isVideoshowPage: PropTypes.bool,
};
Header.defaultProps = {
  hideL2Navigation: false,
  hideOpenInAppTopWidget: false,
  // openappUrl: '',
  currentCountry: undefined,
  l1Sections: [],
  l2Sections: [],
  showTOIPlus: false,
  // showShortLogo: false,
  userData: undefined,
  underToneAd: undefined,
  hideAds: false,
  // geolocation: '1',
  gaCategory: undefined,
  isOpenInApp: false,
  headerType: '',
  showToiPlusEntryPoints: false,
  headerLabel: '',
  hideLogoMastHead: false,
  disableTimesPointWidget: false,
  pageType: '',
  toipLayout: false,
  // isShowSearch: false,
  showHeaderOnScroll: false,
  isPrime: false,
  hideStickyL2Nav: false,
  abHeaderId: '',
  abAdskey: '',
  isLiveblogListing: false,
  isMastHeadH1: true,
  mastheadText: '',
  jarvisConfig: {},
  isWapView: true,
  removeOneTap: false,
  l1NavSections: [],
  headerSlugAdCodeObject: undefined,
  enableHeaderUnificationVersion: false,
  disableCityNavBreakdown: false,
  isUsHomePage: false,
  isVideoshowPage: false,
};

const mapStateToProps = state => ({
  // isShowSearch: _get(state, 'articleshow_v2.isShowSearchOverlay', false),
  isPrime: state.isPrime,
  jarvisConfig: _get(state, 'common.siteConfig.revenue', {}),
  abAdskey: _get(state, `common.siteConfig.abexperiment.abAdskey`, ''),
  abHeaderId: _get(
    state,
    `common.siteConfig.abexperiment.header_as_lb.experimentid`,
    '',
  ),
  geoCityData: state.geo.cityData,
  l1NavSections: _get(state, 'header.data.navigation.l1items', null),
});

// const mapDispatchToProps = dispatch => ({
//   updateSearchOverlayStatus: params => {
//     dispatch(updateSearchOverlayStatus(params));
//   },
// });
export default connect(mapStateToProps)(Header);
